type QueuedHttp = { post: Function };
type ApiPathLike = { table: { getSummaryTableDataUrl: (id: string | number) => string } };

export class SummaryTableBackendServiceTS {
  private readonly queuedHttp: QueuedHttp;
  private readonly apiPath: ApiPathLike;

  constructor(queuedHttp: QueuedHttp, apiPath: ApiPathLike) {
    this.queuedHttp = queuedHttp;
    this.apiPath = apiPath;
  }

  async fetchJson(tableId: string | number, chartIndex: number, requestParams: any) {
    const url = this.apiPath.table.getSummaryTableDataUrl(tableId) + "?chart_index=" + chartIndex;
    return this.queuedHttp.post(url, requestParams);
  }

  getRepresentation(resultData: any) {
    // Pass-through: no transformation
    return resultData;
  }
}

export function createAngularCompatibleSummaryTableService(queuedHttp: QueuedHttp, apiPath: ApiPathLike) {
  const service = new SummaryTableBackendServiceTS(queuedHttp, apiPath);
  return {
    fetchJson: service.fetchJson.bind(service),
    getRepresentation: service.getRepresentation.bind(service),
  };
}

